import React from 'react';
import { TaskStateIcon } from './SharedComponents';

interface LenderTaskItemProps {
  task: any;
  handlerClickTask: (task: any) => void;
}

export const LenderTaskItem: React.FC<LenderTaskItemProps> = ({ task, handlerClickTask }) => {
  return (
    <div
      className={`task-item task-item-${task.state}`}
      style={{ cursor: (task.loanDoc?.file?.url && !task.loanDoc?.hidden) ? 'pointer' : 'default' }}
      onClick={() => handlerClickTask(task)}
    >
      <TaskStateIcon state={task.state} />
      <span>{task.text}</span>
      {task.state === 'BLOCKED' && !task.loanDoc && (
        <b>| Complete <strong>&#8594;</strong></b>
      )}
      {task.loanDoc?.file?.url && !task.loanDoc.hidden && (
        <b>| View <strong>&#8594;</strong></b>
      )}
    </div>
  );
};